import MUITypography from '@mui/material/Typography'
import type { SxProps } from '@mui/material'

export default function Typography({
  sx,
  children,
  variant,
  bold,
  color,
  onClick,
  inline,
}: {
  sx?: SxProps
  children: React.ReactNode
  color?: string
  bold?: boolean
  variant?:
    | 'body1'
    | 'body2'
    | 'button'
    | 'caption'
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'inherit'
    | 'overline'
    | 'subtitle1'
    | 'subtitle2'
  onClick?: () => void
  inline?: boolean
}) {
  return (
    <MUITypography
      sx={{
        ...(bold ? { fontWeight: 'bold' } : {}),
        ...(onClick ? { cursor: 'pointer' } : {}),
        ...(sx ?? {}),
        ...(inline ? { display: 'inline' } : {}),
      }}
      variant={variant}
      color={color}
      onClick={onClick}
    >
      {children}
    </MUITypography>
  )
}
